if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      /*
       * Gem præcis det leveringsløfte, der allerede vises i den aktuelle
       * produktsektion. Det ændrer ikke kundens visning eller beregningen.
       */
      const productSection =
        this.closest('[id^="MainProduct-"]') ||
        this.closest('.shopify-section') ||
        this;

      const deliveryStatus =
        productSection.querySelector('#delivery-status');

      const deliveryInterval =
        deliveryStatus?.dataset.deliveryInterval || '';

      const deliveryType =
        deliveryStatus?.dataset.deliveryType || '';

      const deliveryLabel =
        deliveryStatus?.dataset.deliveryLabel || '';

      const intervalInput =
        this.form?.querySelector('[name="properties[Forventet levering]"]');

      const typeInput =
        this.form?.querySelector('[name="properties[_Leveringstype]"]');

      if (deliveryInterval && intervalInput) {
        intervalInput.value = deliveryInterval;
      }

      if (deliveryType && typeInput) {
        typeInput.value = deliveryType;
      }

      const formData = new FormData(this.form);

      if (deliveryInterval) {
        formData.set(
          'properties[Forventet levering]',
          deliveryInterval
        );
      }

      if (deliveryType) {
        formData.set(
          'properties[_Leveringstype]',
          deliveryType
        );
      }
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      const deliveryTypeInput =
  this.form?.querySelector('#delivery-property-type') ||
  this.querySelector('#delivery-property-type');

const selectedDeliveryType =
  deliveryTypeInput?.value ||
  deliveryStatus?.dataset.deliveryType ||
  '';

const shippingGroup =
  selectedDeliveryType === 'kixer_udland'
    ? 'UPS'
    : 'DAO';

formData.set(
  'properties[_Fragtgruppe]',
  shippingGroup
);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });

            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');

            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;

            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          /*
           * Opdater kun ordre-attributterne, når der faktisk findes et løfte.
           * En alternativ add-to-cart-form må aldrig slette et eksisterende
           * løfte ved at skrive tomme strenge.
           */
          if (!deliveryInterval) return response;

          return fetch(
            `${window.Shopify.routes.root}cart/update.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
  attributes: {
    'Lovet levering': deliveryInterval,
    'Leveringstype': deliveryLabel,
  },
}),
            }
          )
  .then(() => {
    if (
      typeof window.syncLetzKickShippingMethod ===
      'function'
    ) {
      return window.syncLetzKickShippingMethod();
    }
  })
  .then(() => response);
        })
        .then((response) => {
          if (!response) return;

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
            });
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if (
            this.cart &&
            this.cart.classList.contains('is-empty')
          ) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          this.querySelector(
            '.loading-overlay__spinner'
          ).classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
